import { MATRIX_BACKEND } from '@/remotes';
import { useNewDataFormCargoPickUpStore } from '@/stores/newFormCargoPickUp';

export async function useFetchDeliveryTimeIntervals(cityId) {
  const dataForm = useNewDataFormCargoPickUpStore();

  const params = new URLSearchParams();

  params.append('cityId', Number(cityId));

  try {
    dataForm.fetchedDeliveryTimeIntervals = (await MATRIX_BACKEND.get('/api/public/available-delivery-time', { params })).data;
  } catch {
    dataForm.fetchedDeliveryTimeIntervals = [];
  }
}
